import { useNavigate } from "react-router-dom";
import { ChevronDown, Copy, UserRound, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// "Kopyala ▾": Hızlı Satış'ta YENİ satış taslağı (kaydetmez). mode=same → cari seçili; other → cari boş/zorunlu
export default function CopyMenu({ o }) {
  const navigate = useNavigate();
  const go = (mode) => navigate(`/hizli-satis?copy=${o.id}&mode=${mode}`);
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild><Button size="sm" variant="outline" data-testid="copy-menu-button"><Copy className="h-4 w-4 mr-1" />Kopyala<ChevronDown className="h-3.5 w-3.5 ml-1" /></Button></DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52" data-testid="copy-menu">
        <DropdownMenuItem onSelect={() => go("same")} data-testid="copy-menu-same"><UserRound className="h-4 w-4 mr-2" />Aynı Müşteri İçin</DropdownMenuItem>
        <DropdownMenuItem onSelect={() => go("other")} data-testid="copy-menu-other"><Users className="h-4 w-4 mr-2" />Farklı Müşteri İçin</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
